import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

// 260608 이벤트 가입(커피 쿠폰) — 별도 진입점 없이 비즈니스 등록(registerNew)에 묻어가는 옵인.
//   여기 라우트는 발급된 쿠폰을 보는 "내 쿠폰" 화면만. 진입은 등록 완료 모달 등에서.
// 260923 대표: 메가커피 이벤트 중단 — 받는 경로(등록 이벤트 트랙·추천코드·공유 페이지)는 전부 걷었다.
//   이미 받은 쿠폰(11/02 만료)과 운영진 발급 패널은 여기서 계속 쓰므로 '내 쿠폰'은 플래그와 떼고 로그인 가드만 둔다
//   (coffee_event.enabled 를 끄면 종전 flag 가드가 보유자까지 막았다).

// 로그인 가드 — 미로그인 시 '/signin' 반환(beforeEnter가 navigation 자체를 리다이렉트해 화면 mount/인증 API 선발사 방지).
const requireLogin = () => {
  const user = store.getters['user/getUserData'];
  if (isEmpty(user.userNo)) return '/signin';
};

export default [
  {
    // 내 쿠폰 — 발급된 쿠폰 바코드·사용 완료 + 운영진 발급/반납 패널. 로그인 가드.
    path: '/event/coupon',
    name: 'event-coupon',
    component: () => import('@/views/event/eventCoupon.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, titleName: '내 쿠폰' },
    beforeEnter: requireLogin
  },
  // 260923 메가커피 공유 페이지 폐지 — 이미 퍼진 링크(카톡·푸시)가 빈 화면에 떨어지지 않게 홈으로(라우터에 catch-all 이 없다).
  { path: '/event/share', redirect: '/intro' }
];
